<script>
  import options from './QuickSearch.options'
  export default options
</script>

<template>
  <article class="nlx-quick-search">
    <div class="nlx-quick-search__container">
      <div class="nlx-quick-search__searchfield">
        <div class="nlx-quick-search__icon-container"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-search" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><circle cx="10" cy="10" r="7"></circle><line x1="21" y1="21" x2="15" y2="15"></line></svg></div>
        <input class="nlx-quick-search__inputfield" v-model="searchString" @keyup.enter="searchNow(searchString)">
        <button @click="clearSearch" class="nlx-quicksearch__clear-search">{{getLabel('clear_search')}}</button>
      </div>
      <div class="nlx-quick-search__button-container">
        <button @click="copyFromClipboard" class="nlx-button nlx-quick-search__button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="currentColor"
            viewBox="0 0 32 32"
          >
            <path d="M20 3h-1.5C17.7 1.6 16.5 1 15 1s-2.7.6-3.5 2H10a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm-5-1c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm7 26H10V6h1.5c.7 1.2 2 2 3.5 2s2.8-.8 3.5-2H22v22z"/>
            <rect x="11" y="10" width="10" height="1.5" rx=".75" />
            <rect x="11" y="13.5" width="10" height="1.5" rx=".75" />
            <rect x="11" y="17" width="8" height="1.5" rx=".75" />
          </svg>
          <p>{{getLabel('paste')}}</p>
        </button>
        <a
          v-if="excelHelpLink"
          :href="excelHelpLink"
          target="_blank"
          rel="noopener"
          class="nlx-button nlx-quick-search__button"
        >
        <svg 
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g>
            <path 
              d="M256,80A176,176,0,1,0,432,256,176,176,0,0,0,256,80Z" 
              style="fill:none;stroke:#ffffff;stroke-miterlimit:10;stroke-width:32px"></path>
            <path 
              d="M200,202.29s.84-17.5,19.57-32.57C230.68,160.77,244,158.18,256,158c10.93-.14,20.69,1.67,26.53,4.45,10,4.76,29.47,16.38,29.47,41.09,0,26-17,37.81-36.37,50.8S251,281.43,251,296" 
              style="fill:none;stroke:#ffffff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:28px"></path>
            <circle cx="250" cy="348" r="20" style="fill:none;stroke:#ffffff;stroke-width:28px"></circle>
          </g>
        </svg>
          <p>{{getLabel('help')}}</p>
        </a>
      </div>
    </div>
    <p class="nlx-quick-search__error-text" v-if="copyError">{{getLabel('copyFromClipboardError')}}</p>
  </article>
</template>
